import { SVGProps, Ref, forwardRef } from 'react';

export const CubeOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .5 1 4v8l7 3.5 7-3.5V4zm4.652 3.891L8 6.717 3.348 4.391 8 2.065zM7.3 13.585l-4.9-2.45V5.483l4.9 2.45zm6.3-2.45-4.9 2.45V7.933l4.9-2.45z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CubeOutlinedSize16Glyph.displayName = 'CubeOutlinedSize16Glyph';
